module.exports = __webpack_public_path__ + "img/appAsset-brand--axteroid-icon--dark.06cf396e.svg";